(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/render-bigstat-modal.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/render-bigstat-modal.js');
'use strict';

const BigStatModalContainer = svs.components.sportinfo.bigstat.BigStatModalContainer;
const logger = svs.core.log.getLogger('bigstat:render-bigstat-modal');
const unmountBigStatModal = domElement => {
  ReactDOM.unmountComponentAtNode(domElement);
};
const renderToDom = (querySelector, props, BigStatProps) => {
  ReactDOM.render(React.createElement(BigStatModalContainer, {
    BigStatProps,
    className: 'big-stat-modal',
    isOpen: props.isOpen,
    closeNavigationCallback: props.closeNavigationCallback,
    unmountBigStatCallback: props.unmountBigStatCallback,
    closeToPath: props.closeToPath
  }, null), document.querySelector(querySelector));
};
const renderBigStatModal = (querySelector, props, BigStatProps) => {
  if (!querySelector) {
    logger.warn("No valid query selector: ".concat(props));
    return;
  }
  renderToDom(querySelector, props, BigStatProps);
};
setGlobal('svs.components.sportinfo.bigstat.renderBigStatModal', renderBigStatModal);
setGlobal('svs.components.sportinfo.bigstat.unmountBigStatModal', unmountBigStatModal);

 })(window);